import {WikiUpdateUserSettingsArgs} from '~shared/schema/wiki/actions/user-settings';

import {WikiUserSettings} from '~shared/models';

import {IS_INTERNAL} from '~ui/constants';
import {createThunk, makeThunkErrorHandler} from '~ui/store/utils';

import {i18n} from '~ui/components/AsideNavigation/i18n';

import {prepareJsonPatch} from './utils';

const errorHandler = makeThunkErrorHandler({
    name: 'update-settings-error',
    title: i18n('settings-update-error'),
    content: i18n('settings-update-error-description'),
});

export const updateUserSettings = createThunk(
    'user-settings/update',
    async (settings: WikiUpdateUserSettingsArgs, thunkAPI) => {
        const sdk = thunkAPI.extra.sdk;

        const {theme, language, ...otherSettings} = settings;

        if (IS_INTERNAL) {
            return sdk.wiki
                .updateUserSettings({
                    theme,
                    language,
                    ...otherSettings,
                })
                .catch(errorHandler);
        }

        return sdk.iam
            .updateUserAccountSettings({
                jsonPatch: prepareJsonPatch({
                    theme,
                    language,
                    // store wiki specific settings in `wiki`,
                    // so we dont pollute settings object
                    // that could be used in other services
                    wiki: otherSettings,
                }),
            })
            .then((data) => {
                const {theme, language, wiki} = data.userSettings;
                return {
                    theme,
                    language,
                    ...wiki,
                } as WikiUserSettings;
            })
            .catch(errorHandler);
    },
);
